import React from 'react'
import PropTypes from 'prop-types'
import apiFetch from '../../../apiFetch.js'
import ErrorList from './ErrorList.js'

export default class PasswordResertSendEmailForm extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      error: null,
      waitingForServer: false,
      email: this.props.email || ''
    }
  }

  static get propTypes () {
    return {
      email: PropTypes.string,
      onCompletion: PropTypes.func.isRequired,
      isMobile: PropTypes.bool.isRequired,
     }
  }

  render () {
    const classes = this.props.isMobile ? 'form ui' : null
    return (
      <form onSubmit={e => this.handleFormSubmit(e)} className={classes}>
        <p>
          Enter your email and we will send you an email with a code you can
          use to reset your password.
        </p>

        <ErrorList error={this.state.error} />

        <fieldset className='loginFields' disabled={this.state.waitingForServer}>
          <div className='loginRow loginLast'>
            <label htmlFor='PasswordReset-email'>Email Address:</label>
            <input
              id='PasswordReset-email'
              type='email'
              name='email'
              size='30'
              placeholder='email'
              onChange={e => this.handleInputChange(e)}
              value={this.state.email}
              required
            />
          </div>

          <input
            className='loginSubmit'
            type='submit'
            value={this.state.waitingForServer ? 'Submitting…' : 'Send Email'}
          />
        </fieldset>
      </form>
    )
  }

  handleInputChange (e) {
    this.setState({ email: e.target.value })
  }

  handleFormSubmit (e) {
    e.preventDefault()

    this.setState({ error: null, waitingForServer: true })

    const email = this.state.email.trim()
    apiFetch('POST', 'Login/PasswordResetRequest', { email })
      .then(() => {
        this.setState({ waitingForServer: false })
        this.props.onCompletion(email)
      })
      .catch(error => this.setState({ error, waitingForServer: false }))
  }
}
